import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *回复列表
 * @param params
 * 
*/

export const discussList = params => Http.get(`${baseUrl}/activity/discuss`, { params })

/**
 *修改(仅自己)
 * @param params 
 * 
*/

export const editDiscuss = params  => Http.put(`${baseUrl}/activity/discuss`, params)

/**
 *删除(仅自己)
 * @param discussId
 * 
*/

export const delDiscuss = discussId => Http.delete(`${baseUrl}/activity/discuss/${discussId }`)

/**
 *回复
 * @param params
 * 
*/

export const replyDiscuss = params => Http.post(`${baseUrl}/activity/discuss`,  params )

/**
 *点赞
 * @param discussId
 * 
*/

export const starDiscuss = discussId => Http.post(`${baseUrl}/activity/discuss/${discussId }/star`)

/**
 *取消点赞
 * @param discussId
 * 
*/

export const cancelStarDiscuss = discussId => Http.post(`${baseUrl}/activity/discuss/${discussId }/cancelStar`)